<script>
    import {
        currentJob, currentPosition, modal
    } from './stores.js';
    import BouncyBtnJobHunt from "./BouncyBtnJobHunt.svelte";
    import Action_JobAds from "./Action_JobAds.svelte";

    const openJobAds = () => {
        // TODO
        modal.set(Action_JobAds)
    }
</script>

<div>
    <table>
        <tbody>
        <tr>
            <td><b>Job Position</b></td>
            <td>{$currentJob.name}</td>
        </tr>
        <tr>
            <td><b>Employer</b></td>
            <td>{$currentJob.employer}</td>
        </tr>
        <tr>
            <td><b>Daily Wage</b></td>
            <td>{($currentJob.yearly_salary[$currentPosition] / 260).toFixed(2)}</td>
        </tr>
        <tr>
            <td><b>Promotion</b></td>
            <td>{$currentPosition} / {$currentJob.yearly_salary.length}</td>
        </tr>
        <tr>
            <td><b>Your Performance</b></td>
            <td>
                Based on various stats related to work (TODO)
            </td>
        </tr>
        </tbody>
    </table>
    <BouncyBtnJobHunt height={50} width={140} amount={20} duration={600} gluten on:click={openJobAds}>Job Ads</BouncyBtnJobHunt>

</div>

<style>
    div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    table {
        border-collapse: collapse;
        margin: 25px 0;
        font-size: 0.9em;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
    }
    table thead tr {
        background-color: #009879;
        color: #ffffff;
        text-align: left;
    }
    table th,
    table td {
        padding: 12px 15px;
    }
    table tbody tr {
        border-bottom: 1px solid #dddddd;
    }

    table tbody tr:nth-of-type(even) {
        background-color: #f3f3f3;
    }

    table tbody tr:last-of-type {
        border-bottom: 2px solid #009879;
    }
    table tbody tr.active-row {
        font-weight: bold;
        color: #009879;
    }
</style>